// @TODO: remove old styles
/**
 * Ryan O'Dowd
 * 2022-04-16
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, safeAreaInsets}) => {
  return {
    innerContainer: {
      flex: 1, // @TODO: why isn't this full width on web?
    },
    list: {
      paddingBottom: safeAreaInsets.bottom,
    },
    profileDetails: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 0,
      paddingRight: 16,
      paddingLeft: 16,
    },
    nameWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
    },
    pencilIcon: {
      marginTop: 0,
      marginBottom: 0,
    },
    followButtonWrapper: {
      display: 'flex',
    },
    userInfoWrapper: {
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    userInfoTextWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      marginLeft: 16,
    },
    displayName: {
      fontSize: globalScale * 24,
      fontFamily: fonts.secondaryBold,
    },
    username: {
      fontSize: globalScale * 18,
    },
    profilePicture: {
      width: globalScale * 64,
      height: globalScale * 64,
      borderRadius: globalScale * 20,
      backgroundColor: colors.primaryDark,
    },
    providerInfoWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
    },
    providerIcon: {
      fontSize: globalScale * 18,
      paddingRight: globalScale * 4,
      color: colors.white,
    },
    userInfoText: {
      fontSize: globalScale * 14,
      color: colors.white,
    },
    lastRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    userMetadata: { // @TODO: probably need more room for longer provider info...wrap?
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    emptyScreenWrapper: {
      minHeight: 180, // @TODO: to avoid jank...maybe shouldn't be hardcoded?
    },
    sectionWrapper: {
      borderTopColor: `${colors.lightGray}44`,
      borderTopWidth: 2,
      marginTop: 12,
      padding: 8,
    },
    sectionHeaderText: {
      fontSize: globalScale * 20,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },

    contributionGraphWrapper: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    streakWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    currentStreakWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: globalScale * 24,
      height: globalScale * 24,
      paddingLeft: globalScale * 8,
      paddingRight: globalScale * 8,
      marginLeft: globalScale * 8,
      backgroundColor: colors.accent,
      borderRadius: globalScale * 15,
    },
    currentStreakWrapperLoggedInUser: {
      backgroundColor: colors.complete, // @TODO: different color
    },
    incompleteStreak: {
      backgroundColor: colors.gray,
    },
    userToDisplayBackground: {
      backgroundColor: colors.accent,
    },
    loggedInUserBackground: {
      backgroundColor: colors.complete,
    },
    streakText: {
      fontSize: globalScale * 16,
      color: colors.white,
      fontFamily: fonts.primaryBold,
    },
    currentStreakText: {
      color: colors.black,
    },
    wrinklesButtonWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 16,
    },

    peanutsGraphWrapper: {
      marginTop: 16,
    },
    reportUserText: {
      color: colors.alert,
    },
    editDialog: {
      top: -128, // @TODO: this is a hack because dialog keyboard avoiding is too hard...i _think_ this should be fine on all device sizes, but just be careful with this
    },
    dialogText: {
      color: colors.dialogText,
    },
  };
};

export default getStyles;
